import { Pin } from '@vis.gl/react-google-maps'
import { MdOutlinePerson } from 'react-icons/md'

export const MePin = (): JSX.Element => (
  <Pin
    background='white'
    borderColor='#FF5733'
  >
    <MdOutlinePerson />
  </Pin>
)
